import {Representante} from "../../composicao-acionaria/model/composicao-acionaria.model";

export class Termos {
  parceiroId: string;
  termos: Array<Termo> = [];
  constructor(other?: any) {
    if(other) {
      this.parceiroId = other.parceiroId;
      if(other != null && other instanceof Array) {
        other.forEach((value) => { this.termos.push(new Termo(value)); });
      }
    }
  }
}

export class Termo {
  id: string;
  status: string;
  tipoTermo: string;
  dataAssinaturaTermo: string;
  ultimaAtualizacao: string;

  constructor(other?: any) {
    if(other) {
      this.id = other.id;
      this.status = other.status;
      this.tipoTermo = other.tipoTermo;
      this.dataAssinaturaTermo = other.dataAssinaturaTermo;
      this.ultimaAtualizacao = other.ultimaAtualizacao
    }
  }
}
